import React, { useState, useRef, useEffect } from "react";
import { toast } from "react-toastify";
import "./ContactUs.scss";
import axios from "axios";
import Navbar from "../../components/Navbar/Navbar.jsx";
import {
  StyledButton,
  StyledCheckbox,
  StyledTextField,
  theme,
} from "../doctor-console/StyledComponents.js";
import {
  Container,
  Grid,
  Card,
  Autocomplete,
  FormControlLabel,
  FormControl,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ThemeProvider } from "@mui/material/styles";
import { productsAndServicesOptions } from "./Utils/Utils.js";

const useStyles = makeStyles({
  asterisk: {
    color: "red",
  },
});
function ContactUs() {
  const classes = useStyles();
  const [states, setStates] = useState([]);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const [formDetails, setFormDetails] = useState({
    firstName: "",
    lastName: "",
    jobTitle: "",
    email: "",
    phone: "",
    company: "",
    state: "",
    productsAndServices: "",
    checked: false,
  });
  useEffect(() => {
    axios
      .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_states/`, {
        headers: headers,
      })
      .then((res) => {
        setStates(res.data.state_list);
        console.log("States", res.data.state_list);
      });
  }, []);
  const form = useRef();
  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (formDetails.phone && !/^[6-9]\d{9}$/.test(formDetails.phone)) {
      return;
    }
    const postBody = {
      SENDER: "Ankit Raj <ankit.raj@exavalu.com>",
      RECIPIENT: "akshay.shukla@exavalu.com",
      SUBJECT: "test",
      TYPE: "CONTACTUS",
      first_name: formDetails.firstName,
      last_name: formDetails.lastName,
      job_title: formDetails.jobTitle,
      email: formDetails.email,
      company: formDetails.company,
      product_services: formDetails.productsAndServices,
      state: formDetails.state,
      phone: formDetails.phone,
    };
    axios
      .post(`${process.env.REACT_APP_BACKEND_ROUTE_URL}send_email/`, postBody)
      .then((response) => {
        if (response.data.Status === "completed") {
          toast.success("Form Submitted Successfully");
        } else {
          toast.error("Form Submission Failed");
        }
      })
      .catch((error) => {
        console.error("Error sending email", error);
        toast.error("Form Submission Failed");
      });
    console.log("Contact Us Form Submit");
    console.log(formDetails);

    // emailjs
    //   .sendForm(
    //     "service_xvyerov",
    //     "template_ab0wtss",
    //     form.current,
    //     "Dh2qFyW94DVOApzwi"
    //   )
    //   .then(
    //     (result) => {
    //       console.log("FORM SENT"); //This is if you still want the page to reload (since e.preventDefault() cancelled that behavior)
    //     },
    //     (error) => {
    //       console.log("FORM SEND FAILED");
    //       console.log(error.text);
    //     }
    //   );

    console.log("FORM SENT");

    setFormDetails({
      firstName: "",
      lastName: "",
      jobTitle: "",
      email: "",
      phone: "",
      company: "",
      state: "",
      productsAndServices: "",
      checked: false,
    });
  };

  const handleChangeFormDetails = (field, value) => {
    setFormDetails({
      ...formDetails,
      [field]: value,
    });
  };

  return (
    <ThemeProvider theme={theme}>
      <Navbar />

      {/* Contact Us starts */}

      <Container className="fontFamily">
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Card className="contactFormCard">
              <Typography variant="h4" gutterBottom className="h4Styling">
                How would you like to contact HlthTek Optimus?
              </Typography>
              <div>
                <Typography variant="h5" gutterBottom className="h5Styling">
                  Request a call. <br /> Give us some info so the right person
                  can get back to you
                </Typography>

                <form
                  ref={form}
                  onSubmit={handleFormSubmit}
                  enctype="text/plain"
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <StyledTextField
                        fullWidth
                        label="First Name"
                        value={formDetails.firstName}
                        onChange={(e) =>
                          handleChangeFormDetails("firstName", e.target.value)
                        }
                        name="First_Name"
                        id="First_Name"
                        placeholder="First Name"
                        required
                        InputLabelProps={{
                          classes: { asterisk: classes.asterisk },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <StyledTextField
                        fullWidth
                        label="Last Name"
                        value={formDetails.lastName}
                        onChange={(e) =>
                          handleChangeFormDetails("lastName", e.target.value)
                        }
                        name="Last_Name"
                        id="Last_Name"
                        placeholder="Last Name"
                        required
                        InputLabelProps={{
                          classes: { asterisk: classes.asterisk },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <StyledTextField
                        fullWidth
                        label="Job Title"
                        value={formDetails.jobTitle}
                        onChange={(e) =>
                          handleChangeFormDetails("jobTitle", e.target.value)
                        }
                        name="Job_Title"
                        id="Job_Title"
                        placeholder="Job Title"
                        required
                        InputLabelProps={{
                          classes: { asterisk: classes.asterisk },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <StyledTextField
                        fullWidth
                        label="Email"
                        value={formDetails.email}
                        onChange={(e) =>
                          handleChangeFormDetails("email", e.target.value)
                        }
                        name="Email"
                        id="Email"
                        placeholder="Email"
                        type="email"
                        required
                        InputLabelProps={{
                          classes: { asterisk: classes.asterisk },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <StyledTextField
                        fullWidth
                        label="Phone"
                        value={formDetails.phone}
                        onChange={(e) =>
                          handleChangeFormDetails("phone", e.target.value)
                        }
                        name="Phone"
                        id="Phone"
                        placeholder="Phone"
                        type="number"
                        error={
                          formDetails.phone &&
                          !/^[6-9]\d{9}$/.test(formDetails.phone)
                        }
                        helperText={
                          formDetails.phone &&
                          !/^[6-9]\d{9}$/.test(formDetails.phone)
                            ? "Phone number must start with 6-9 and be 10 digits long."
                            : ""
                        }
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <StyledTextField
                        fullWidth
                        label="Company"
                        value={formDetails.company}
                        onChange={(e) =>
                          handleChangeFormDetails("company", e.target.value)
                        }
                        name="Company"
                        id="Company"
                        placeholder="Company"
                        required
                        InputLabelProps={{
                          classes: { asterisk: classes.asterisk },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl fullWidth>
                        <Autocomplete
                          id="state-autocomplete"
                          options={states}
                          getOptionLabel={(option) => option.state_name}
                          value={
                            formDetails.state
                              ? { state_name: formDetails.state }
                              : null
                          }
                          onChange={(event, newValue) => {
                            handleChangeFormDetails(
                              "state",
                              newValue ? newValue.state_name : ""
                            );
                          }}
                          renderInput={(params) => (
                            <StyledTextField
                              {...params}
                              label="Select State"
                              variant="outlined"
                            />
                          )}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl fullWidth>
                        <Autocomplete
                          id="products-services-autocomplete"
                          options={productsAndServicesOptions}
                          value={formDetails.productsAndServices || ""}
                          onChange={(event, newValue) => {
                            handleChangeFormDetails(
                              "productsAndServices",
                              newValue || ""
                            );
                          }}
                          renderInput={(params) => (
                            <StyledTextField
                              {...params}
                              label="Products & Services"
                              variant="outlined"
                              required
                              InputLabelProps={{
                                classes: { asterisk: classes.asterisk },
                              }}
                            />
                          )}
                        />
                      </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                      <FormControlLabel
                        control={
                          <StyledCheckbox
                            checked={formDetails.checked}
                            onChange={(e) =>
                              handleChangeFormDetails(
                                "checked",
                                e.target.checked
                              )
                            }
                            name="Checkbox"
                            required
                          />
                        }
                        label="By registering you confirm that you agree to the storing and processing of your personal data"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <StyledButton
                        type="submit"
                        variant="contained"
                        color="defaultColor"
                      >
                        Contact Me
                      </StyledButton>
                    </Grid>
                  </Grid>
                </form>
              </div>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card className="contactFormCard">
              <Typography variant="h5" gutterBottom className="h5Styling">
                Give us a call.
              </Typography>
              <Typography variant="h6" gutterBottom className="h6Styling">
                +91-9073940606
              </Typography>
              <StyledButton href="#" variant="contained" color="defaultColor">
                Get billing and tech support
              </StyledButton>
            </Card>
            <Card className="contactFormCard">
              <Typography variant="h5" gutterBottom className="h5Styling">
                Chat with us
              </Typography>
              <Typography variant="body1" gutterBottom className="body1Styling">
                Get product info, login help and live chat with an agent.
              </Typography>
              <StyledButton variant="contained" color="defaultColor">
                Let's chat
              </StyledButton>
            </Card>
            <Card className="contactFormCard">
              <Typography variant="h5" gutterBottom className="h5Styling">
                Leave us some feedback
              </Typography>
              <Typography variant="body1" gutterBottom className="body1Styling">
                Good or bad, we love to hear it all.
              </Typography>
              <StyledButton variant="contained" color="defaultColor">
                Send Feedback
              </StyledButton>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </ThemeProvider>
  );
}

export default ContactUs;
